import { render } from "./QuestionPage.vue?vue&type=template&id=a3c62710&scoped=true"
import script from "./QuestionPage.vue?vue&type=script&lang=js"
export * from "./QuestionPage.vue?vue&type=script&lang=js"

import "./QuestionPage.vue?vue&type=style&index=0&id=a3c62710&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3c62710"]])

export default __exports__